import {
  LeadConversationDetailSchema,
  PrivacyRequestDetailSchema,
  type LeadConversationDetailDto,
  type PrivacyRequestDetailDto,
} from '@devmil/contracts';

/**
 * Conversas e pedidos ILUSTRATIVOS, para o modo fixture.
 *
 * Nada aqui veio de pessoa nenhuma. Os textos dizem, no próprio corpo, que são
 * exemplo: fixture com dado que parece verdadeiro vira peça publicada no dia em
 * que alguém copiar dela. Os quatro pseudônimos são os MESMOS que a tabela
 * aprovada do MAPA já mostra, senão o clique na tabela cairia em 404 no modo
 * que o Thiago usa para revisar a tela.
 *
 * Telefone: só os 4 últimos dígitos, e ainda assim `0000`, que é um valor que
 * não existe em lugar nenhum. O telefone inteiro nunca chega ao painel, nem em
 * fixture.
 */

const detalhe = (dado: unknown): LeadConversationDetailDto =>
  // Validar a fixture no mesmo schema da API: fixture que não passa no
  // contrato é fixture que mente sobre o formato do dado real.
  LeadConversationDetailSchema.parse(dado);

const pedido = (dado: unknown): PrivacyRequestDetailDto =>
  PrivacyRequestDetailSchema.parse(dado);

export const ILLUSTRATIVE_LEADS: readonly LeadConversationDetailDto[] = [
  detalhe({
    id: 'a7f2c1d4-3b5e-4f2a-9c81-0d6e2f5a7b31',
    pseudonym: 'lead_a7f2',
    stage: 'link_issued',
    currentQuestion: null,
    startedAt: '2026-08-27T11:04:00Z',
    lastInteractionAt: '2026-08-27T18:12:00Z',
    windowEndsAt: '2026-08-28T11:04:00Z',
    automationAllowed: true,
    retentionClass: 'qualified',
    purgeAfter: '2027-02-27T11:04:00Z',
    destination: 'whatsapp',
    revision: 3,
    answers: [
      {question: 'company_type', value: 'Exemplo ilustrativo de segmento'},
      {
        question: 'time_consuming_task',
        value: 'Exemplo ilustrativo de tarefa repetitiva relatada',
      },
      {question: 'frequency', value: 'daily'},
      {question: 'platforms', value: ['Exemplo A', 'Exemplo B']},
      {question: 'whatsapp_permission', value: true},
    ],
    noticeAcknowledgedAt: '2026-08-27T11:05:00Z',
    whatsappConsent: 'granted',
    phoneLast4: null,
    outbound: [
      {state: 'sent', createdAt: '2026-08-27T11:06:00Z'},
      {state: 'sent', createdAt: '2026-08-27T18:12:00Z'},
    ],
  }),
  detalhe({
    id: '91bc7a3e-5d10-4c88-b2f4-6a9e1c3d7042',
    pseudonym: 'lead_91bc',
    stage: 'channels_linked',
    currentQuestion: null,
    startedAt: '2026-08-26T09:40:00Z',
    lastInteractionAt: '2026-08-27T10:02:00Z',
    windowEndsAt: '2026-08-27T09:40:00Z',
    automationAllowed: false,
    retentionClass: 'qualified',
    purgeAfter: '2027-02-26T09:40:00Z',
    destination: 'whatsapp',
    revision: 7,
    answers: [
      {question: 'company_type', value: 'Exemplo ilustrativo de segmento'},
      {
        question: 'time_consuming_task',
        value: 'Exemplo ilustrativo de tarefa repetitiva relatada',
      },
      {question: 'frequency', value: 'weekly'},
      {question: 'platforms', value: ['Exemplo A']},
      {question: 'whatsapp_permission', value: true},
    ],
    noticeAcknowledgedAt: '2026-08-26T09:41:00Z',
    whatsappConsent: 'granted',
    phoneLast4: '0000',
    outbound: [{state: 'sent', createdAt: '2026-08-26T09:42:00Z'}],
  }),
  detalhe({
    id: '3d10f5b8-2c47-4e19-8a6d-71b0e4c9f253',
    pseudonym: 'lead_3d10',
    stage: 'question_frequency',
    currentQuestion: 'frequency',
    startedAt: '2026-08-28T02:15:00Z',
    lastInteractionAt: '2026-08-28T03:00:00Z',
    windowEndsAt: '2026-08-29T02:15:00Z',
    automationAllowed: true,
    retentionClass: 'incomplete',
    purgeAfter: '2026-09-27T02:15:00Z',
    destination: 'none',
    revision: 2,
    answers: [
      {question: 'company_type', value: 'Exemplo ilustrativo de segmento'},
      {
        question: 'time_consuming_task',
        value: 'Exemplo ilustrativo de tarefa repetitiva relatada',
      },
    ],
    noticeAcknowledgedAt: '2026-08-28T02:16:00Z',
    whatsappConsent: 'not_asked',
    phoneLast4: null,
    outbound: [{state: 'sent', createdAt: '2026-08-28T02:16:00Z'}],
  }),
  detalhe({
    id: 'f0483b9c-6e21-4d75-9f38-5c2a8d1e6047',
    pseudonym: 'lead_f048',
    stage: 'human_handoff',
    currentQuestion: null,
    startedAt: '2026-08-20T13:30:00Z',
    lastInteractionAt: '2026-08-25T16:45:00Z',
    windowEndsAt: '2026-08-21T13:30:00Z',
    automationAllowed: false,
    retentionClass: 'qualified',
    purgeAfter: '2027-02-20T13:30:00Z',
    destination: 'human',
    revision: 11,
    answers: [
      {question: 'company_type', value: 'Exemplo ilustrativo de segmento'},
      {
        question: 'time_consuming_task',
        value: 'Exemplo ilustrativo de tarefa repetitiva relatada',
      },
      {question: 'frequency', value: 'monthly'},
      {question: 'platforms', value: ['Exemplo A', 'Exemplo C']},
      {question: 'whatsapp_permission', value: false},
    ],
    noticeAcknowledgedAt: '2026-08-20T13:31:00Z',
    whatsappConsent: 'revoked',
    phoneLast4: null,
    outbound: [{state: 'blocked', createdAt: '2026-08-25T16:45:00Z'}],
  }),
];

export const ILLUSTRATIVE_PRIVACY_REQUESTS: readonly PrivacyRequestDetailDto[] =
  [
    pedido({
      id: 'c4e18a26-9b70-4f31-8d52-3a7c6e0b9145',
      right: 'access',
      status: 'verified',
      verificationChannel: 'instagram',
      subjectVerifiedAt: '2026-08-27T14:20:00Z',
      dueAt: '2026-09-10T12:00:00Z',
      completedAt: null,
      operationAuditRef: '7b2d95f1-0c48-4a63-9e17-8d5f3b6c2a90',
      propagations: [],
      delivery: {state: 'none', expiresAt: null},
    }),
    pedido({
      id: 'd83f4b07-1e59-4c26-b7a0-9f2e5d8c1364',
      right: 'erasure',
      status: 'verification_pending',
      verificationChannel: 'whatsapp',
      subjectVerifiedAt: null,
      dueAt: '2026-09-12T12:00:00Z',
      completedAt: null,
      operationAuditRef: '2f6a8c14-7d90-4b52-8e31-6c0d9a5f7b28',
      propagations: [
        {
          target: 'postgres',
          state: 'pending',
          evidenceHash: null,
          updatedAt: '2026-08-28T09:00:00Z',
        },
        {
          target: 'object_storage',
          state: 'pending',
          evidenceHash: null,
          updatedAt: '2026-08-28T09:00:00Z',
        },
      ],
      delivery: null,
    }),
    pedido({
      id: 'e51c7d92-4a86-4b03-9c78-1d6b2f4e8503',
      right: 'consent_revocation',
      status: 'completed',
      verificationChannel: 'whatsapp',
      subjectVerifiedAt: '2026-08-22T10:05:00Z',
      dueAt: '2026-09-05T12:00:00Z',
      completedAt: '2026-08-22T10:40:00Z',
      operationAuditRef: '9a3e6b57-2c81-4f40-b96d-4e7a1c8f5b23',
      // `null`, e não uma entrega vencida: `loadRequestDetail` monta `delivery`
      // só para `access`. Revogação de consentimento não tem entrega, e ensaiar
      // um estado que a API nunca produz é a fixture mentindo sobre o formato.
      propagations: [
        {
          target: 'postgres',
          state: 'completed',
          evidenceHash:
            '0000000000000000000000000000000000000000000000000000000000000000',
          updatedAt: '2026-08-22T10:40:00Z',
        },
        {
          target: 'n8n_execution_data',
          state: 'not_applicable_verified',
          evidenceHash: null,
          updatedAt: '2026-08-22T10:38:00Z',
        },
      ],
      delivery: null,
    }),
  ];
